import * as React from 'react';

import { LinkButton } from '@cian/ui-kit';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { IExtraBtnProps } from '../../../../containers/QuizPersonalApplicationContainer/types';

export const HomeLinkButton: React.FC<React.PropsWithChildren<IExtraBtnProps>> = ({ onClick }) => {
  const isDesktop = useIsDesktop();

  return (
    <LinkButton href="https://cian.ru" fullWidth={!isDesktop} onClick={onClick}>
      Перейти на главную
    </LinkButton>
  );
};

HomeLinkButton.displayName = 'HomeLinkButton';
